import request from '@/utils/request';

const baseURL = process.env.VUE_APP_SORTING;

/**
 * 查询分拣数量统计总览图表。
 * @param {Object} data - 查询参数
 * @param {string} data.machineCode - 分拣机编码
 * @param {number} data.metricType - 统计类型：1-格口，2-供包台，3-规则命中
 * @param {string} data.queryType - 查询类型：HOUR、DAY、WEEK、MONTH、CUSTOM
 * @param {string[]} [data.dimensionKeys] - 指定维度主键列表
 * @param {string} [data.startTime] - 自定义开始时间
 * @param {string} [data.endTime] - 自定义结束时间
 * @returns {Promise}
 */
export function getAllCountChart(data) {
  return request({
    baseURL,
    url: '/metric/allCountChart',
    method: 'post',
    data,
    isLoading: false
  });
}

/**
 * 查询分拣数量统计维度下钻图表。
 * @param {Object} data - 查询参数
 * @param {string} data.machineCode - 分拣机编码
 * @param {number} data.metricType - 统计类型：1-格口，2-供包台，3-规则命中
 * @param {string} data.queryType - 查询类型：HOUR、DAY、WEEK、MONTH、CUSTOM
 * @param {string[]} [data.dimensionKeys] - 指定维度主键列表
 * @param {string} [data.startTime] - 自定义开始时间
 * @param {string} [data.endTime] - 自定义结束时间
 * @returns {Promise}
 */
export function getDimensionCountChart(data) {
  return request({
    baseURL,
    url: '/metric/dimensionCountChart',
    method: 'post',
    data,
    isLoading: false
  });
}
